import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  Select,
} from '@chakra-ui/react';
import CustomInput from '../Common/Input';
import { useTranslation } from 'react-i18next';

export default function ModalTemporadas({ isOpen, onClose }) {
  const { t } = useTranslation();
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      closeOnOverlayClick={true}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t('UPDATE_SEASON')}</ModalHeader>
        <ModalCloseButton />

        <ModalBody>
          <CustomInput
            label={t('SEASON_START')}
            type="date"
            name="fechaFirma"
            value={'01-01-2024'}
            max={new Date().toISOString().split('T')[0]}
          />
          <CustomInput
            label={t('SEASON_END')}
            type="date"
            name="fechaFirma"
            value={'01-01-2024'}
            max={new Date().toISOString().split('T')[0]}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
